<template>
    <modal :visible.sync="isShowDialog" :title="$t(title)" width="600px">
        <el-form ref="form" :model="dioForm" :rules="rules" label-width="160px">
            <el-form-item :label="$t('public.table_scope')" prop="scope"
                v-if="$store.state.type === 3 || $store.state.type === 2">
                <el-select v-model="dioForm.scope" style="width: 250px">
                    <el-option v-for="item in scopeArrays" :key="item.code" :label="item.name" :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item :label="$t('public.reason')" prop="title">
                <el-input v-model.trim="dioForm.title" style="width: 250px"></el-input>
            </el-form-item>
            <el-form-item :label="$t('public.table_desc')" prop="describe">
                <el-input v-model.trim="dioForm.describe" type="textarea" :autosize="{ minRows: 2, maxRows: 4 }"
                    style="width:250px" maxlength="250" show-word-limit></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer">
            <el-button type="primary" @click="isShowDialog = false">{{ $t('public.btn_close') }}</el-button>
            <el-button type="primary" @click="handleSave">{{ $t('public.btn_confirm') }}</el-button>
        </div>
    </modal>
</template>

<script>

import { exReasonAdd, exReasonUpdate } from '@/api/modules/abReason.js';

export default {

    props: ['isShow', 'title', 'scopeArrays', 'editForm'],
    watch: {
        editForm(newVal) {
            this.dioForm = { ...newVal }
        }
    },
    computed: {
        isSysAdmin() {
            const currentUser = this.$store.getters.userInfo.scope;
            return currentUser.sysScope && currentUser.sysAdmin || currentUser.sysScope && !currentUser.sysAdmin
        },
        isShowDialog: {
            get: function () {
                return this.isShow
            },
            set: function (val) {
                this.$emit('update:isShow', val);
            }
        },
        rules() {
            return {
                title: [{ required: true, message: $t('integration.reason_cannot_be_empty'), trigger: 'blur' },
                {
                    max: 20,
                    message: $t('public.len_max_20'),
                    trigger: 'blur'
                }
                ]
            }
        }
    },
    data() {
        return {
            dioForm: {
                title: '',
                scope: '',
                describe: ''
            },
            // isShowMsg: false
        }
    },
    methods: {
        async justify() {
            // 校验成功则方法自动返回true，校验方法报错则说明校验失败，返回false
            try {
                return await this.$refs['form'].validate()
            } catch (error) {
                return false
            }
        },
        clearValidate() {
            if (this.$refs.form) {
                this.$refs.form.resetFields();
            }
        },
        async handleSave() {
            const flag = await this.justify();
            if (!flag) return

            let httpUrl = exReasonAdd;
            if (this.dioForm.id) {
                httpUrl = exReasonUpdate
            }
            httpUrl(this.dioForm).then(({ result }) => {
                if (result === 400) {
                    this.$message.error($t('integration.fail'))
                }
                else if (result === 200) {
                    this.$message.success($t('integration.success'));
                    this.isShowDialog = false;
                    this.$parent.getListFn();
                }
                else if (result === 406) {
                    this.$message.error($t('integration.name_already_exists'))
                }
                else {
                    this.$message.error($t('integration.data_error'))
                }
            })
        }
    }
}
</script>

<style></style>
